import DayList from '../../slices/day/DayList'
import DayDetails from '../../slices/day/DayDetails'

const dayReducer = {
    dayList: DayList,
    dayDetails: DayDetails,
};

export default dayReducer;
